/**
 * @generated SignedSource<<4bfbada37175b60c05abdab4dd8d0552>>
 * @relayHash 5ad4af803c98133647e9759cb6889b8d
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/424.0.0-2023-08-04T08:32:19.033Z/pdpSharedNotificationMultiplePdpVisitsModalConfigQuery

import { ConcreteRequest, Query } from 'relay-runtime';
export type pdpSharedNotificationMultiplePdpVisitsModalConfigQuery$variables = {
  itemIds: ReadonlyArray<string | null>;
};
export type pdpSharedNotificationMultiplePdpVisitsModalConfigQuery$data = {
  readonly viewer: {
    readonly itemRead: ReadonlyArray<{
      readonly isAuctionEnabled?: boolean | null;
      readonly isPrivateVisibilityType?: boolean | null;
      readonly pricing?: {
        readonly bargain: boolean | null;
      } | null;
      readonly status?: string | null;
    } | null> | null;
  };
};
export type pdpSharedNotificationMultiplePdpVisitsModalConfigQuery = {
  response: pdpSharedNotificationMultiplePdpVisitsModalConfigQuery$data;
  variables: pdpSharedNotificationMultiplePdpVisitsModalConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itemIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "itemIds"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivateVisibilityType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPricing",
      "kind": "LinkedField",
      "name": "pricing",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bargain",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/424.0.0-2023-08-04T08:32:19.033Z/pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
    "metadata": {},
    "name": "pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6841cbb12254ed54f06592ca76317ac7";

export default node;
